module.exports = __webpack_public_path__ + "img/join-akira-gold.80613512.png";